// extracted by mini-css-extract-plugin
export var background = "styles-module--background--8062a";
export var badge = "styles-module--badge--5c280";
export var badgeIcon = "styles-module--badgeIcon--afad8";
export var caption = "styles-module--caption--4e2b3";
export var centerAligned = "styles-module--centerAligned--d59eb";
export var closeBtn = "styles-module--closeBtn--bde1b";
export var fallbackContainer = "styles-module--fallbackContainer--103bc";
export var format11 = "styles-module--format11--11cc3";
export var format169 = "styles-module--format169--59734";
export var format34 = "styles-module--format34--c6421";
export var format43 = "styles-module--format43--6b19d";
export var formatWrapper = "styles-module--formatWrapper--b2f11";
export var img = "styles-module--img--054e4";
export var leftAligned = "styles-module--leftAligned--dfc9b";
export var rightAligned = "styles-module--rightAligned--48ff6";
export var showing = "styles-module--showing--f07e4";
export var svgImg = "styles-module--svgImg--52f36";
export var zoomedImg = "styles-module--zoomedImg--25e2b";